import { baseURL } from "../../utils/misc";


 export const getNutrientMaturityStagesOfCrop = async (token) => {
  const requestOptions = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  // Return the fetch Promise
  return await fetch(`${baseURL}/nutrientmanagementrecords/maturity-stages-of-crop`, requestOptions)
    .then((response) => { 
      if (!response.ok) {
        return;
      }
      
      return response.json();
    })
    .then((data) => {
      return data; // Return the data as a resolved value
    })
    .catch((error) => {
      console.error("Error fetching Maturity Stages Of Crop!", error);
      throw error; // Rethrow the error to propagate it to the caller
    });
};


export const getNutrientIngredientQuantityUnit = async (token) => {
  const requestOptions = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  // Return the fetch Promise
  return await fetch(`${baseURL}/nutrientmanagementrecords/ingredient-quantity-units`, requestOptions)
    .then((response) => { 
      if (!response.ok) {
        return;
      }
      
      return response.json();
    })
    .then((data) => {
      return data; // Return the data as a resolved value
    })
    .catch((error) => {
      console.error("Error fetching Ingredient Quantity Units!", error);
      throw error; // Rethrow the error to propagate it to the caller
    });
};


export const getNutrientSources = async (token) => {
  const requestOptions = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  // Return the fetch Promise
  return await fetch(`${baseURL}/miscellaneous/material-sources`, requestOptions)
    .then((response) => { 
      if (!response.ok) {
        return;
      }
      
      return response.json();
    })
    .then((data) => {
      return data; // Return the data as a resolved value
    })
    .catch((error) => {
      console.error("Error fetching Sources", error);
      throw error; // Rethrow the error to propagate it to the caller
    });
};


export const getNutrientRecordsByCropId = async (token, cropId) => {
  const requestOptions = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  // Return the fetch Promise
  return await fetch(`${baseURL}/nutrientmanagementrecords/crop/${cropId}`, requestOptions)
    .then((response) => { 
      if (!response.ok) {
        return;
      }
      
      return response.json();
    })
    .then((data) => {
      return data; // Return the data as a resolved value
    })
    .catch((error) => {
      console.error("Error fetching Nutrient Records!", error);
      throw error; // Rethrow the error to propagate it to the caller
    });
};